import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';
import InfoTooltip from 'components/info_tooltip';
import { observer } from 'mobx-react';
import React from 'react';
import LeagueUserRow from './league_user_row';

const ZoneWrapper = styled.div`
  background-color: ${props => props.color || 'transparent'};
  border-radius: 5px;
  padding: ${props => props.padding || '10px'};
  width: 500px;
  position: relative;
  @media (max-width: 500px) {
    width: 100%;
  }
`;

const ZoneTitle = styled.div`
  color: ${props => props.color || Theme.darkGray};
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  i {
    margin-right: 5px;
  }
`;

const TooltipWrapper = styled.div`
  position: absolute;
  top: 15px;
  right: 10px;
`;

const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const TableCell = styled.div`
  font-size: 14px;
  color: ${Theme.darkGray};
`;

@observer
class LeagueZone extends React.Component {
  render() {
    if (this.props.leagues.length === 0) return null;

    return (
      <ZoneWrapper
        color={this.props.color}
        padding={this.props.promotionStatus === 0 ? '5px 10px' : '10px'}
      >
        {
          this.props.showTooltip && (
            <TooltipWrapper>
              <InfoTooltip
                position='left'
                color='white'
              >
                {this.props.tooltipText}
              </InfoTooltip>
            </TooltipWrapper>
          )
        }
        {
          this.props.title && (
            <ZoneTitle color={this.props.titleColor}>
              <i className={this.props.iconClass} />
              {this.props.title}
            </ZoneTitle>
          )
        }
        <Table>
          {
            this.props.leagues.map(userLeague => (
              <LeagueUserRow
                key={userLeague.id}
                userLeague={userLeague}
                userId={this.props.userId}
                promotionStatus={this.props.promotionStatus}
              />
            ))
          }
        </Table>
      </ZoneWrapper>
    );
  }
}

export default LeagueZone;